// extracted by mini-css-extract-plugin
export default {"backgroundColor":"About_backgroundColor__iXvKx","title":"About_title__23Cln"};